import { FC } from 'react';

import _ from '../../locale';
import { styled } from '../../theme';
import Button from '../Button';

const ColorScaleControlsContainer = styled('div')({
    position: 'absolute',
    top: -130,
    display: 'inline-grid',
    '> :first-of-type': {
        marginBottom: 10,
    },
});

const ColorScaleControl = styled(Button)({
    width: 110,
    minWidth: 110,
    minHeight: 34,
    height: 34,
});

type Props = {
    setScale: (min: number, max: number) => void;
    resetScale: () => void;
};

export const MapChartColorScaleControls: FC<Props> = ({ setScale, resetScale }) => (
    <div style={{ position: 'relative' }}>
        <ColorScaleControlsContainer>
            <ColorScaleControl onClick={setScale}>{_('map_chart_set_scale')}</ColorScaleControl>
            <ColorScaleControl onClick={resetScale}>{_('map_chart_reset_scale')}</ColorScaleControl>
        </ColorScaleControlsContainer>
    </div>
);

export default MapChartColorScaleControls;
